/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const kioskPreloaderSchema = z
	.object({
		id: z.uuid(),
		url: z.string().nullable(),
		media_type: z.string(),
		duration: z.int().nullable().describe("Секунды показа изображения; у видео null — показывается целиком."),
		order: z.int(),
	})
	.describe("Сериализатор прелоадера киоска.");
